// A workspace banner's band (LoadBanner, OffersBanner): coming in, the band opens (so the panes under it glide
// down, never jump), then the card settles in from 4px above, unblurring, its buttons a beat after; going, the card
// lifts 4px and fades as the band closes, quicker. One already up when the page loads stays put (usePresence).
// Mac: Banner.swift bannerCard / BannerIn.

import { useRef, type ReactNode } from 'react';
import { usePresence } from './ds';

const EXIT_MS = 180;

export function BannerSlot({ open, children }: { open: boolean; children: ReactNode }) {
  const p = usePresence(open, EXIT_MS);
  // what it showed, kept while it leaves (the caller has nothing to show by then)
  const last = useRef<ReactNode>(children);
  if (open) last.current = children;
  if (!p.mounted) return null;
  return (
    <div className="ws-banner-slot" data-shown={p.shown ? '' : undefined} data-leaving={p.leaving ? '' : undefined}>
      <div className="ws-banner-slot-in">{open ? children : last.current}</div>
    </div>
  );
}
